import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { ILinksGroup, ILinksSubgroups, IPromo } from 'src/shared/types/link';

@Component({
    selector: 'website-header-v2-section-placeholder',
    template: `@if (linksSubgroups) {
            <ul>
                @for (group of linksSubgroups?.subgroups; track group.title || $index) {
                    <li>
                        <div [innerHTML]="group.title"></div>
                        <ng-container
                            [ngTemplateOutlet]="linksGroupTemplate"
                            [ngTemplateOutletContext]="group"
                        ></ng-container>
                    </li>
                }
            </ul>
        }

        @if (linksGroup) {
            <ng-container [ngTemplateOutlet]="linksGroupTemplate" [ngTemplateOutletContext]="linksGroup"></ng-container>
        }

        <ng-template #linksGroupTemplate let-links="links">
            @if (links) {
                <ul>
                    @for (link of links; track link.url || link.title || $index) {
                        <li>
                            <a [href]="link.url">
                                <p>{{ link.title }}</p>
                                <p>{{ link.description }}</p>
                            </a>
                        </li>
                    }
                </ul>
            }
        </ng-template>

        @if (promo) {
            @if (promo.link_text && promo.link_url) {
                <a [href]="promo.link_url">
                    <ng-container [ngTemplateOutlet]="promoCard"></ng-container>
                </a>
            } @else {
                <div>
                    @if (promo.title) {
                        <div [innerHTML]="promo.title"></div>
                    }
                    @if (promo.description) {
                        <div [innerHTML]="promo.description"></div>
                    }
                    @if (promo.link_url && promo.link_text) {
                        <div [innerHTML]="promo.link_text"></div>
                    }
                </div>
            }
        }

        <ng-template #promoCard>
            <div>
                @if (promo.title) {
                    <div [innerHTML]="promo.title"></div>
                }
                @if (promo.description) {
                    <div [innerHTML]="promo.description"></div>
                }
                @if (promo.link_url && promo.link_text) {
                    <span [innerHTML]="promo.link_text"></span>
                }
            </div>
        </ng-template> `,
    standalone: true,
    styles: `
        :host {
            display: none;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgTemplateOutlet],
})
export class HeaderV2SectionPlaceholderComponent {
    @Input() linksSubgroups: ILinksSubgroups;
    @Input() linksGroup: ILinksGroup;
    @Input() promo: IPromo;
}
